import type { LinkProps } from '@/ui-components/atoms/Link/Link';
import type { FooterItem } from '@/ui-components/organisms/Footer/FullFooter.type';

export interface NavigationFooterLink extends LinkProps {
    authenticatedLink?: LinkProps;
}

export interface NavigationFooterGroup extends Omit<FooterItem, 'footerLinkItems'> {
    footerLinkItems: NavigationFooterLink[];
}

export function mapSiteLinkToFooterLink(link: SiteLink): NavigationFooterLink {
    const authenticatedFields = link.fields.authenticated_link?.fields;

    return {
        href: link.fields.href,
        children: link.fields.link_text,
        ...(authenticatedFields?.href
            ? {
                  authenticatedLink: {
                      href: authenticatedFields.href,
                      children: authenticatedFields.link_text || link.fields.link_text,
                  },
              }
            : {}),
    };
}

export function hasAuthenticatedFooterLinks(groups: NavigationFooterGroup[]): boolean {
    return groups.some((group) => group.footerLinkItems.some((link) => Boolean(link.authenticatedLink?.href)));
}

export function resolveFooterLinks(groups: NavigationFooterGroup[], isAuthenticated: boolean): FooterItem[] {
    return groups.map((group) => ({
        ...group,
        footerLinkItems: group.footerLinkItems.map(({ authenticatedLink, ...defaultLink }) =>
            isAuthenticated && authenticatedLink?.href ? { ...defaultLink, ...authenticatedLink } : defaultLink,
        ),
    }));
}
